import { useChatContext } from '@/chat/ChatContext';
import { PROFESSIONAL_LABELS } from '@/i18n/maps';
import { ChipAwareMarkdown } from '@/markdown/chips';
import type { ProfessionalsListSection } from '@/types/chat';

export function ProfessionalsListView({
  section,
}: {
  section: ProfessionalsListSection;
}): JSX.Element {
  const { locale } = useChatContext();
  const categories = (section.categories ?? []).filter((cat) => Boolean(PROFESSIONAL_LABELS[cat]));
  return (
    <section className="tw-text-[14px] tw-text-cal-ink-soft tw-leading-relaxed">
      {section.intro_md && (
        <ChipAwareMarkdown
          source={section.intro_md}
          className="tw-mb-2"
        />
      )}
      <ul className="tw-list-disc tw-pl-5 tw-space-y-1">
        {categories.map((cat) => (
          <li key={cat}>{PROFESSIONAL_LABELS[cat][locale] ?? PROFESSIONAL_LABELS[cat].fr}</li>
        ))}
      </ul>
    </section>
  );
}
